import {
  COUNTRIES, GENDERS, DAYS, MONTHS, FORM_TEXTS
} from '@jotforminc/constants';
import { objectEntries } from '@jotforminc/utils';
import { fillArray, debounce, getJSON, assignObject, classNames } from './utils'

let lastHundredYears = [];
(function () {
  const date = new Date();
  // get current year
  const cyear = (date.getYear() < 1000) ? date.getYear() + 1900 : date.getYear();
  const years = [];
  for (let year = cyear; year >= (cyear - 100); year--) {
    years.push(`${year}`);
  }

  lastHundredYears = years;
}());

if (typeof String.prototype.locale === 'undefined') {
  String.prototype.locale = function () {
    return this.toString();
  };
}

const specialOptions = {
  None: {
    controls: 'dropdown,radio,checkbox,matrix'
  },
  'US States': {
    controls: 'dropdown',
    value: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
  },
  'US States Abbr': {
    controls: 'dropdown',
    value: ['AL', 'AK', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY']
  },
  'Canadian Provinces': {
    controls: 'dropdown',
    value: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon']
  },
  Countries: {
    controls: 'dropdown',
    value: COUNTRIES.map(country => country.locale())
  },
  'Last 100 Years': {
    controls: 'dropdown',
    value: lastHundredYears
  },
  Gender: {
    controls: 'dropdown,radio,checkbox',
    value: GENDERS.map(gender => gender.locale())
  },
  Days: {
    controls: 'dropdown,radio,checkbox',
    value: DAYS.map(day => day.locale())
  },
  Months: {
    controls: 'dropdown,radio,checkbox',
    value: MONTHS.map(month => month.locale()),
    nonLocale: MONTHS
  },
  'Time Zones': {
    controls: 'dropdown',
    value: ['[[Africa]]', 'Abidjan (GMT)', 'Accra (GMT)', 'Addis Ababa (GMT+03:00)', 'Algiers (GMT+01:00)', 'Asmara (GMT+03:00)', 'Bamako (GMT)', 'Bangui (GMT+01:00)', 'Banjul (GMT)', 'Bissau (GMT)', 'Blantyre (GMT+02:00)', 'Brazzaville (GMT+01:00)', 'Bujumbura (GMT+02:00)', 'Cairo (GMT+03:00)', 'Casablanca (GMT)', 'Ceuta (GMT+02:00)', 'Conakry (GMT)', 'Dakar (GMT)', 'Dar es Salaam (GMT+03:00)', 'Djibouti (GMT+03:00)', 'Douala (GMT+01:00)', 'El Aaiun (GMT)', 'Freetown (GMT)', 'Gaborone (GMT+02:00)', 'Harare (GMT+02:00)', 'Johannesburg (GMT+02:00)', 'Kampala (GMT+03:00)', 'Khartoum (GMT+03:00)', 'Kigali (GMT+02:00)', 'Kinshasa (GMT+01:00)', 'Lagos (GMT+01:00)', 'Libreville (GMT+01:00)', 'Lome (GMT)', 'Luanda (GMT+01:00)', 'Lubumbashi (GMT+02:00)', 'Lusaka (GMT+02:00)', 'Malabo (GMT+01:00)', 'Maputo (GMT+02:00)', 'Maseru (GMT+02:00)', 'Mbabane (GMT+02:00)', 'Mogadishu (GMT+03:00)', 'Monrovia (GMT)', 'Nairobi (GMT+03:00)', 'Ndjamena (GMT+01:00)', 'Niamey (GMT+01:00)', 'Nouakchott (GMT)', 'Ouagadougou (GMT)', 'Porto-Novo (GMT+01:00)', 'Sao Tome (GMT)', 'Tripoli (GMT+02:00)', 'Tunis (GMT+02:00)', 'Windhoek (GMT+01:00)', '[[America]]', 'Adak (GMT-09:00)', 'Anchorage (GMT-08:00)', 'Anguilla (GMT-04:00)', 'Antigua (GMT-04:00)', 'Araguaina (GMT-03:00)', 'Buenos Aires, Argentina (GMT-03:00)', 'Catamarca, Argentina (GMT-03:00)', 'Cordoba, Argentina (GMT-03:00)', 'Jujuy, Argentina (GMT-03:00)', 'La Rioja, Argentina (GMT-03:00)', 'Mendoza, Argentina (GMT-03:00)', 'Rio Gallegos, Argentina (GMT-03:00)', 'Salta, Argentina (GMT-03:00)', 'San Juan, Argentina (GMT-03:00)', 'San Luis, Argentina (GMT-04:00)', 'Tucuman, Argentina (GMT-03:00)', 'Ushuaia, Argentina (GMT-03:00)', 'Aruba (GMT-04:00)', 'Asuncion (GMT-04:00)', 'Atikokan (GMT-05:00)', 'Bahia (GMT-03:00)', 'Barbados (GMT-04:00)', 'Belem (GMT-03:00)', 'Belize (GMT-06:00)', 'Blanc-Sablon (GMT-04:00)', 'Boa Vista (GMT-04:00)', 'Bogota (GMT-05:00)', 'Boise (GMT-06:00)', 'Cambridge Bay (GMT-06:00)', 'Campo Grande (GMT-04:00)', 'Cancun (GMT-05:00)', 'Caracas (GMT-04:30)', 'Cayenne (GMT-03:00)', 'Cayman (GMT-05:00)', 'Chicago (GMT-05:00)', 'Chihuahua (GMT-06:00)', 'Costa Rica (GMT-06:00)', 'Cuiaba (GMT-04:00)', 'Curacao (GMT-04:00)', 'Danmarkshavn (GMT)', 'Dawson (GMT-07:00)', 'Dawson Creek (GMT-07:00)', 'Denver (GMT-06:00)', 'Detroit (GMT-04:00)', 'Dominica (GMT-04:00)', 'Edmonton (GMT-06:00)', 'Eirunepe (GMT-04:00)', 'El Salvador (GMT-06:00)', 'Fortaleza (GMT-03:00)', 'Glace Bay (GMT-03:00)', 'Godthab (GMT-02:00)', 'Goose Bay (GMT-03:00)', 'Grand Turk (GMT-04:00)', 'Grenada (GMT-04:00)', 'Guadeloupe (GMT-04:00)', 'Guatemala (GMT-06:00)', 'Guayaquil (GMT-05:00)', 'Guyana (GMT-04:00)', 'Halifax (GMT-03:00)', 'Havana (GMT-04:00)', 'Hermosillo (GMT-07:00)', 'Indianapolis, Indiana (GMT-04:00)', 'Knox, Indiana (GMT-05:00)', 'Marengo, Indiana (GMT-04:00)', 'Petersburg, Indiana (GMT-04:00)', 'Tell City, Indiana (GMT-05:00)', 'Vevay, Indiana (GMT-04:00)', 'Vincennes, Indiana (GMT-04:00)', 'Winamac, Indiana (GMT-04:00)', 'Inuvik (GMT-06:00)', 'Iqaluit (GMT-04:00)', 'Jamaica (GMT-05:00)', 'Juneau (GMT-08:00)', 'Louisville, Kentucky (GMT-04:00)', 'Monticello, Kentucky (GMT-04:00)', 'La Paz (GMT-04:00)', 'Lima (GMT-05:00)', 'Los Angeles (GMT-07:00)', 'Maceio (GMT-03:00)', 'Managua (GMT-06:00)', 'Manaus (GMT-04:00)', 'Marigot (GMT-04:00)', 'Martinique (GMT-04:00)', 'Mazatlan (GMT-06:00)', 'Menominee (GMT-05:00)', 'Merida (GMT-05:00)', 'Mexico City (GMT-05:00)', 'Miquelon (GMT-02:00)', 'Moncton (GMT-03:00)', 'Monterrey (GMT-05:00)', 'Montevideo (GMT-03:00)', 'Montreal (GMT-04:00)', 'Montserrat (GMT-04:00)', 'Nassau (GMT-04:00)', 'New York (GMT-04:00)', 'Nipigon (GMT-04:00)', 'Nome (GMT-08:00)', 'Noronha (GMT-02:00)', 'Center, North Dakota (GMT-05:00)', 'New Salem, North Dakota (GMT-05:00)', 'Panama (GMT-05:00)', 'Pangnirtung (GMT-04:00)', 'Paramaribo (GMT-03:00)', 'Phoenix (GMT-07:00)', 'Port-au-Prince (GMT-05:00)', 'Port of Spain (GMT-04:00)', 'Porto Velho (GMT-04:00)', 'Puerto Rico (GMT-04:00)', 'Rainy River (GMT-05:00)', 'Rankin Inlet (GMT-05:00)', 'Recife (GMT-03:00)', 'Regina (GMT-06:00)', 'Resolute (GMT-05:00)', 'Rio Branco (GMT-04:00)', 'Santarem (GMT-03:00)', 'Santiago (GMT-04:00)', 'Santo Domingo (GMT-04:00)', 'Sao Paulo (GMT-03:00)', 'Scoresbysund (GMT)', 'Shiprock (GMT-06:00)', 'St Barthelemy (GMT-04:00)', 'St Johns (GMT-02:30)', 'St Kitts (GMT-04:00)', 'St Lucia (GMT-04:00)', 'St Thomas (GMT-04:00)', 'St Vincent (GMT-04:00)', 'Swift Current (GMT-06:00)', 'Tegucigalpa (GMT-06:00)', 'Thule (GMT-03:00)', 'Thunder Bay (GMT-04:00)', 'Tijuana (GMT-07:00)', 'Toronto (GMT-04:00)', 'Tortola (GMT-04:00)', 'Vancouver (GMT-07:00)', 'Whitehorse (GMT-07:00)', 'Winnipeg (GMT-05:00)', 'Yakutat (GMT-08:00)', 'Yellowknife (GMT-06:00)', '[[Antarctica]]', 'Casey (GMT+11:00)', 'Davis (GMT+05:00)', 'DumontDUrville (GMT+10:00)', 'Mawson (GMT+05:00)', 'McMurdo (GMT+12:00)', 'Palmer (GMT-04:00)', 'Rothera (GMT-03:00)', 'South Pole (GMT+12:00)', 'Syowa (GMT+03:00)', 'Vostok (GMT+06:00)', '[[Arctic]]', 'Longyearbyen (GMT+02:00)', '[[Asia]]', 'Aden (GMT+03:00)', 'Almaty (GMT+06:00)', 'Amman (GMT+03:00)', 'Anadyr (GMT+13:00)', 'Aqtau (GMT+05:00)', 'Aqtobe (GMT+05:00)', 'Ashgabat (GMT+05:00)', 'Baghdad (GMT+03:00)', 'Bahrain (GMT+03:00)', 'Baku (GMT+05:00)', 'Bangkok (GMT+07:00)', 'Beirut (GMT+03:00)', 'Bishkek (GMT+06:00)', 'Brunei (GMT+08:00)', 'Choibalsan (GMT+08:00)', 'Chongqing (GMT+08:00)', 'Colombo (GMT+05:30)', 'Damascus (GMT+03:00)', 'Dhaka (GMT+07:00)', 'Dili (GMT+09:00)', 'Dubai (GMT+04:00)', 'Dushanbe (GMT+05:00)', 'Gaza (GMT+03:00)', 'Harbin (GMT+08:00)', 'Ho Chi Minh (GMT+07:00)', 'Hong Kong (GMT+08:00)', 'Hovd (GMT+07:00)', 'Irkutsk (GMT+09:00)', 'Jakarta (GMT+07:00)', 'Jayapura (GMT+09:00)', 'Jerusalem (GMT+03:00)', 'Kabul (GMT+04:30)', 'Kamchatka (GMT+13:00)', 'Karachi (GMT+06:00)', 'Kashgar (GMT+08:00)', 'Kathmandu (GMT+05:45)', 'Kolkata (GMT+05:30)', 'Krasnoyarsk (GMT+08:00)', 'Kuala Lumpur (GMT+08:00)', 'Kuching (GMT+08:00)', 'Kuwait (GMT+03:00)', 'Macau (GMT+08:00)', 'Magadan (GMT+12:00)', 'Makassar (GMT+08:00)', 'Manila (GMT+08:00)', 'Muscat (GMT+04:00)', 'Nicosia (GMT+03:00)', 'Novokuznetsk (GMT+07:00)', 'Novosibirsk (GMT+07:00)', 'Omsk (GMT+07:00)', 'Oral (GMT+05:00)', 'Phnom Penh (GMT+07:00)', 'Pontianak (GMT+07:00)', 'Pyongyang (GMT+09:00)', 'Qatar (GMT+03:00)', 'Qyzylorda (GMT+06:00)', 'Rangoon (GMT+06:30)', 'Riyadh (GMT+03:00)', 'Sakhalin (GMT+11:00)', 'Samarkand (GMT+05:00)', 'Seoul (GMT+09:00)', 'Shanghai (GMT+08:00)', 'Singapore (GMT+08:00)', 'Taipei (GMT+08:00)', 'Tashkent (GMT+05:00)', 'Tbilisi (GMT+04:00)', 'Tehran (GMT+04:30)', 'Thimphu (GMT+06:00)', 'Tokyo (GMT+09:00)', 'Ulaanbaatar (GMT+08:00)', 'Urumqi (GMT+08:00)', 'Vientiane (GMT+07:00)', 'Vladivostok (GMT+11:00)', 'Yakutsk (GMT+10:00)', 'Yekaterinburg (GMT+06:00)', 'Yerevan (GMT+05:00)', '[[Atlantic]]', 'Azores (GMT)', 'Bermuda (GMT-03:00)', 'Canary (GMT+01:00)', 'Cape Verde (GMT-01:00)', 'Faroe (GMT+01:00)', 'Madeira (GMT+01:00)', 'Reykjavik (GMT)', 'South Georgia (GMT-02:00)', 'St Helena (GMT)', 'Stanley (GMT-04:00)', '[[Australia]]', 'Adelaide (GMT+09:30)', 'Brisbane (GMT+10:00)', 'Broken Hill (GMT+09:30)', 'Currie (GMT+10:00)', 'Darwin (GMT+09:30)', 'Eucla (GMT+08:45)', 'Hobart (GMT+10:00)', 'Lindeman (GMT+10:00)', 'Lord Howe (GMT+10:30)', 'Melbourne (GMT+10:00)', 'Perth (GMT+08:00)', 'Sydney (GMT+10:00)', '[[Europe]]', 'Amsterdam (GMT+02:00)', 'Andorra (GMT+02:00)', 'Athens (GMT+03:00)', 'Belgrade (GMT+02:00)', 'Berlin (GMT+02:00)', 'Bratislava (GMT+02:00)', 'Brussels (GMT+02:00)', 'Bucharest (GMT+03:00)', 'Budapest (GMT+02:00)', 'Chisinau (GMT+03:00)', 'Copenhagen (GMT+02:00)', 'Dublin (GMT+01:00)', 'Gibraltar (GMT+02:00)', 'Guernsey (GMT+01:00)', 'Helsinki (GMT+03:00)', 'Isle of Man (GMT+01:00)', 'Istanbul (GMT+03:00)', 'Jersey (GMT+01:00)', 'Kaliningrad (GMT+03:00)', 'Kiev (GMT+03:00)', 'Lisbon (GMT+01:00)', 'Ljubljana (GMT+02:00)', 'London (GMT+01:00)', 'Luxembourg (GMT+02:00)', 'Madrid (GMT+02:00)', 'Malta (GMT+02:00)', 'Mariehamn (GMT+03:00)', 'Minsk (GMT+03:00)', 'Monaco (GMT+02:00)', 'Moscow (GMT+04:00)', 'Oslo (GMT+02:00)', 'Paris (GMT+02:00)', 'Podgorica (GMT+02:00)', 'Prague (GMT+02:00)', 'Riga (GMT+03:00)', 'Rome (GMT+02:00)', 'Samara (GMT+05:00)', 'San Marino (GMT+02:00)', 'Sarajevo (GMT+02:00)', 'Simferopol (GMT+03:00)', 'Skopje (GMT+02:00)', 'Sofia (GMT+03:00)', 'Stockholm (GMT+02:00)', 'Tallinn (GMT+03:00)', 'Tirane (GMT+02:00)', 'Uzhgorod (GMT+03:00)', 'Vaduz (GMT+02:00)', 'Vatican (GMT+02:00)', 'Vienna (GMT+02:00)', 'Vilnius (GMT+03:00)', 'Volgograd (GMT+04:00)', 'Warsaw (GMT+02:00)', 'Zagreb (GMT+02:00)', 'Zaporozhye (GMT+03:00)', 'Zurich (GMT+02:00)', '[[Indian]]', 'Antananarivo (GMT+03:00)', 'Chagos (GMT+06:00)', 'Christmas (GMT+07:00)', 'Cocos (GMT+06:30)', 'Comoro (GMT+03:00)', 'Kerguelen (GMT+05:00)', 'Mahe (GMT+04:00)', 'Maldives (GMT+05:00)', 'Mauritius (GMT+04:00)', 'Mayotte (GMT+03:00)', 'Reunion (GMT+04:00)', '[[Pacific]]', 'Apia (GMT-11:00)', 'Auckland (GMT+12:00)', 'Chatham (GMT+12:45)', 'Easter (GMT-06:00)', 'Efate (GMT+11:00)', 'Enderbury (GMT+13:00)', 'Fakaofo (GMT-10:00)', 'Fiji (GMT+12:00)', 'Funafuti (GMT+12:00)', 'Galapagos (GMT-06:00)', 'Gambier (GMT-09:00)', 'Guadalcanal (GMT+11:00)', 'Guam (GMT+10:00)', 'Honolulu (GMT-10:00)', 'Johnston (GMT-10:00)', 'Kiritimati (GMT+14:00)', 'Kosrae (GMT+11:00)', 'Kwajalein (GMT+12:00)', 'Majuro (GMT+12:00)', 'Marquesas (GMT-09:30)', 'Midway (GMT-11:00)', 'Nauru (GMT+12:00)', 'Niue (GMT-11:00)', 'Norfolk (GMT+11:30)', 'Noumea (GMT+11:00)', 'Pago Pago (GMT-11:00)', 'Palau (GMT+09:00)', 'Pitcairn (GMT-08:00)', 'Ponape (GMT+11:00)', 'Port Moresby (GMT+10:00)', 'Rarotonga (GMT-10:00)', 'Saipan (GMT+10:00)', 'Tahiti (GMT-10:00)', 'Tarawa (GMT+12:00)', 'Tongatapu (GMT+13:00)', 'Truk (GMT+10:00)', 'Wake (GMT+12:00)', 'Wallis (GMT+12:00)']
  },
  LocationCountries: {
    controls: 'location',
    value: ['Canada', 'United States', 'Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Ind. Ocean', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Central African Rep.', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocoa (Keeling) Is.', 'Colombia', 'Comoros', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote Divoire', 'Croatia', 'Cuba', 'Curacao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea', 'Kuwait', 'Kyrgyzstan', 'Lao', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Lucia', 'Samoa', 'San Marino', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'eSwatini', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican', 'Venezuela', 'Viet Nam', 'Virgin Islands', 'Western Sahara', 'Yeman', 'Yugoslavia', 'Zaire', 'Zambia']
  },


  /* eslint max-len:1 */

  /**
   * Gets the special options for specific element
   * @example special_options.getByType('dropdown') => ['Months', 'Days', 'US States' .... ]
   * @param {Object} type
   */
  getByType(type) {
    const options = [];
    for (const key in specialOptions) {
      if (specialOptions[key].controls && specialOptions[key].controls.indexOf(type) >= 0) {
        options.push(key);
      }
    }
    return options;
  }
};


export const checkAppointmentAvailability = (day, slot, data) => {
  if (!(day && slot && data && data[day])) return false;
  return data[day][slot];
};

export const initializeAppointment = (props) => {
  const PREFIX = (
    window.location.href.indexOf('jotform.pro') > -1
    || window.location.pathname.indexOf('build') > -1
    || window.location.pathname.indexOf('form-templates') > -1
    || window.location.pathname.indexOf('pdf-templates') > -1
    || window.location.pathname.indexOf('table-templates') > -1
    || window.location.pathname.indexOf('approval-templates') > -1
    || window.location.pathname.indexOf('workflow-templates') > -1
    || window.location.pathname.indexOf('themes') > -1
  ) ? '/server.php' : JotForm.server;

  // boilerplate
  let effectsOut = null;
  let changed = {};
  let constructed = false;
  const { document } = window;
  const wrapper = document.querySelector(`#${props.qid.value}`);
  const uniqueId = props.qid.value;
  const element = wrapper.querySelector('.appointmentField');
  const input = wrapper.querySelector(`#input_${props.id.value}_date`);
  const tzInput = wrapper.querySelector(`#input_${props.id.value}_timezone`);

  const currentYear = new Date().getFullYear();
  let timezonePickerCommon;
  let isTimezonePickerFromCommonLoaded = false;

  const beforeRender = () => {
    if (effectsOut) {
      effectsOut();
      effectsOut = null;
    }
  };

  const afterRender = () => {
    effectsOut = effects();
  };

  const setState = (newState) => {
    const changedKeys = Object.keys(newState).filter(key => state[key] !== newState[key]);

    if (!changedKeys.length) {
      return;
    }

    changed = changedKeys.reduce((acc, key) => assignObject({}, acc, { [key]: state[key] }), changed);

    state = assignObject({}, state, newState);
    if (constructed) {
      render();
    }
  };

  const isStartWeekOnMonday = () => {
    const { startWeekOn: { value: startDay } = { value : 'Sunday' } } = props;
    return !startDay || (startDay === 'Monday');
  };

  const monthNames = () => (JotForm.appointmentCalendarMonthsTranslated || JotForm.appointmentCalendarMonths || JotForm.calendarMonthsTranslated || JotForm.calendarMonths || specialOptions.Months.value).map(monthName => (String.prototype.locale ? monthName.locale() : monthName));
  const daysOfWeek = () => (JotForm.appointmentCalendarDaysTranslated || JotForm.appointmentCalendarDays || specialOptions.Days.value).map(dayName =>
    (String.prototype.locale ? dayName.locale() : dayName)
  );
  // we need remove unnecessary "Sunday", if there is time field on the form
  const dayNames = () => {
    const days = daysOfWeek().length === 8 ? daysOfWeek().slice(1) : daysOfWeek();
    return isStartWeekOnMonday() ? days : [days[days.length - 1]].concat(days.slice(0, 6));
  };

  const oneHour = 1000 * 60 * 60;
  // const oneDay = oneHour * 24;

  const intPrefix = (d) => {
    if (d < 10) {
      return `0${d}`;
    }

    return `${d}`;
  };

  const toFormattedDateStr = (date) => {
    const { dateFormat: { value: format = 'yyyy-mm-dd' } } = props;
    if (!date) return;
    if (typeof date === 'string') {
      const [year, month, day] = date.split('-');
      return format.replace(/yyyy/, year).replace(/mm/, month).replace(/dd/, day);
    }

    const year = date.getFullYear();
    const month = intPrefix(date.getMonth() + 1);
    const day = intPrefix(date.getUTCDate());
    return format.replace(/yyyy/, year).replace(/mm/, month).replace(/dd/, day);
  };

  const toDateStr = (date) => {
    if (!date) return;
    const year = date.getFullYear();
    const month = intPrefix(date.getMonth() + 1);
    const day = intPrefix(date.getDate());

    return `${year}-${month}-${day}`;
  };

  const toDateTimeStr = (date) => {
    if (!date) return;
    const ymd = toDateStr(date);
    const hour = intPrefix(date.getHours());
    const minute = intPrefix(date.getMinutes());
    return `${ymd} ${hour}:${minute}`;
  };

  const getTimezoneOffset = (timezone) => {
    if (!timezone) {
      return 0;
    }
    const cityArgs = timezone.split(' ');
    const splitted = cityArgs[cityArgs.length - 1].replace(/\(GMT|\)/g, '').split(':');

    if (!splitted) {
      return 0;
    }

    return parseInt(splitted[0] || 0, 10) + ((parseInt(splitted[1] || 0, 10) / 60) || 0);
  };

  const getGMTSuffix = (offset) => {
    if (offset === 0) {
      return '';
    }

    const offsetMinutes = Math.abs(offset) % 60;
    const offsetHours = Math.abs(offset - offsetMinutes) / 60;

    const str = `${intPrefix(offsetHours)}:${intPrefix(offsetMinutes)}`;

    if (offset < 0) {
      return `+${str}`;
    }

    return `-${str}`;
  };

  const getYearMonth = (date) => {
    if (!date) return;
    const [y, m] = date.split('-');
    return `${y}-${m}`;
  };

  const getMondayBasedDay = (date) => {
    const day = date.getUTCDay();
    if (day === 0) {
      return 6; // sunday index
    }
    return day - 1;
  };

  const getDay = (date) => {
    return isStartWeekOnMonday() ? getMondayBasedDay(date) : date.getUTCDay();
  };


  const getUserTimezone = () => {
    const { autoDetectTimezone: { value: autoDetectValue } = {}, timezone: { value: timezoneAtProps } = {} } = props;
    if (autoDetectValue === 'No') {
      return timezoneAtProps;
    }

    try {
      const tzStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tzStr) {
        const tz = `${tzStr} (GMT${getGMTSuffix(new Date().getTimezoneOffset())})`;
        return tz;
      }
    } catch (e) {
      console.error(e.message);
    }

    return props.timezone.value;
  };

  const convertStrToTime = ({ dateStr = '', value = '' }) => {
    const calculateVal = toFormattedDateStr(dateStr);
    const {
      timeFormat: { value: timeFormat = '24 Hour' } = {}
    } = props;
    const date = new Date(dateStr);
    const time = new Date((value).replace(/-/g, '/')).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hourCycle: timeFormat === 'AM/PM' ? 'h12' : 'h23' });
    const day = getDay(date);
    const specialDays = specialOptions.Days.value;
    const datetime = `${dayNames()[day]}, ${monthNames()[date.getUTCMonth()]} ${intPrefix(date.getUTCDate())}, ${date.getFullYear()}`;
    const unTranslatedDatetime = `${isStartWeekOnMonday() ? specialDays[day] : [specialDays[specialDays.length - 1]].concat(specialDays.slice(0, 6))[day]}, ${specialOptions.Months.value[date.getUTCMonth()]} ${intPrefix(date.getUTCDate())}, ${date.getFullYear()}`;

    return {
      calculateVal, time, datetime, unTranslatedDatetime
    }
  }

  const hasDatePassed = (givenDateString, comparedDateString = new Date()) => {
    // Parse the given date string and create a date object
    const givenDate = new Date(givenDateString);
    const comparedDate = new Date(comparedDateString);

    // Get today's date with time set to 00:00:00 for accurate comparison
    comparedDate.setHours(0, 0, 0, 0);

    return givenDate < comparedDate;
}

  const passedProps = props;

  let state = {};

  const getStateFromProps = (newProps = {}) => {
    const { timezone: { value: timezoneValue } } = newProps;
    const startDate = new Date(newProps.startDate ? newProps.startDate.value : '');
    const today = new Date();
    const date = toDateStr(new Date(Math.max(startDate, today) || today));

    return {
      date,
      timezones: state ? state.timezones : { loading: true },
      ...(window.location.pathname.indexOf('build') > -1
        ? { timezone: timezoneValue, defaultTimezone: timezoneValue } : {})
    };
  };

  state = getStateFromProps(props);

  const loadTimezones = (cb) => {
    setState({
      timezones: { loading: true }
    });

    const cdnUrl = props.cdnconfig?.CDN.endsWith('/') ? props.cdnconfig.CDN : `${props.cdnconfig.CDN}/`;
    getJSON(`${cdnUrl}assets/form/timezones.json?ncTz=${(new Date().getTime())}`).then((data) => {
      const timezones = objectEntries(data).reduce((acc, [group, cities]) => {
        acc.push({
          group,
          cities
        });
        return acc;
      }, []);

      cb(timezones);
    });
  };

  const loadMonthData = (startDate, endDate, cb) => {
    const { formID = (typeof global === 'object' ? global.__formInfo.id : null), id: { value: id } } = props;
    const { timezone } = state;

    if (!formID || !timezone) return;

    // eslint-disable-next-line max-len
    const url = `${PREFIX}?action=getAppointments&formID=${formID}&qid=${id}&timezone=${encodeURIComponent(timezone)}&startDate=${toDateStr(startDate)}&endDate=${toDateStr(endDate)}&ncTz=${(new Date().getTime())}`;

    return getJSON(url).then(({ content: data }) => cb(data));
  };

  const getMonthData = (startDate, endDate) => {
    let returnData = null;
    const res = loadMonthData(startDate, endDate, (data) => { returnData = data; });

    function _wait(resolve, reject) {
      if (res._complete) {
        resolve(returnData);
      } else {
        setTimeout(_wait.bind(this, resolve, reject), 100);
      }
    }

    return new Promise(_wait);
  }

  const generateMonthData = (startDate, endDate, data) => {
    const d1 = startDate.getDate();
    const d2 = endDate.getDate();
    const dPrefix = `${startDate.getFullYear()}-${intPrefix(startDate.getMonth() + 1)}-`;

    const daysLength = (d2 - d1) + 1 || 0;
    const days = fillArray(new Array(daysLength), '');

    const slots = days.reduce((acc, x, day) => {
      const dayStr = `${dPrefix}${intPrefix(day + 1)}`;
      return assignObject(acc, { [dayStr]: data[dayStr] || false });
    }, {});


    const availableDays = Object.keys(data).filter(d => !Array.isArray(slots[d]) && !!slots[d]);

    return {
      availableDays,
      slots
    };
  };

  let lastReq;

  const updateMonthData = (startDate, endDate, data) => {
    const { availableDays, slots } = generateMonthData(startDate, endDate, data);

    if (JSON.stringify(slots) === JSON.stringify(state.slots)) {
      return;
    }

    setState({
      availableDays,
      slots
    });
  };

  const getDateRange = (dateStr) => {
    const [y, m] = dateStr.split('-');

    const startDate = new Date(y, m - 1, 1);
    const endDate = new Date(y, m, 0);
    return [startDate, endDate];
  };

  const load = () => {
    const { date: dateStr } = state;

    const [startDate, endDate] = getDateRange(dateStr);

    setState(assignObject({ loading: true }, generateMonthData(startDate, endDate, {})));

    const req = loadMonthData(startDate, endDate, (data) => {
      if (lastReq !== req) {
        return;
      }

      updateMonthData(startDate, endDate, data);
      const { availableDays, forcedStartDate, forcedEndDate, slots } = state;

      const firstAvailable = availableDays.find((d) => {
        const foundSlot = Object.keys(slots[d]).find((slot) => {

          const slotDate = new Date(`${d} ${slot}`.replace(/-/g, '/'));

          if (forcedStartDate && slotDate > forcedStartDate) return false;
          if (forcedEndDate && slotDate < forcedEndDate) return false;

          return true;
        });

        return foundSlot;
      });

      const newDate = availableDays.indexOf(dateStr) === -1 && firstAvailable;

      setState({
        loading: false,
        date: newDate || dateStr
      });
    });

    lastReq = req;
  };


  const dz = (date, tz1, tz2) => {
    if (!date) return;
    const diffTime = (tz1 - tz2) * oneHour;
    return new Date(date.getTime() - diffTime);
  };

  const revertDate = (d, t1, t2) => {
    if (!d) return '';

    const pDate = new Date(d.replace(/-/, '/'));
    const utz = getTimezoneOffset(getUserTimezone());
    const tz1 = getTimezoneOffset(t1) - utz;
    const tz2 = getTimezoneOffset(t2) - utz;

    const val = dz(
      pDate,
      tz1,
      tz2
    );

    return toDateTimeStr(val);
  };

  const amPmConverter = (_time) => {
    const {
      timeFormat: { value: timeFormat = '24 Hour' } = {}
    } = props;
    if (!_time
        || !(typeof _time === 'string')
        || (_time.indexOf('M') > -1)
        || !timeFormat
        || (timeFormat === '24 Hour')) {
      return _time;
    }
    const time = _time.substring(0, 2);
    const hour = (time % 12) || 12;
    const ampm = time < 12 ? 'AM' : 'PM';
    return `${hour}${_time.substring(2, 5)} ${ampm}`;
  };

  const validate = (dateStr, cb) => {
    const { defaultValue } = state;

    if (
      JotForm.isEditMode()
      && defaultValue === dateStr
    ) {
      return cb(true);
    }

    const parts = dateStr.split(' ');
    const slot = parts.slice(1).join(' ');
    const [y, m, d] = parts[0].split('-');

    const startDate = new Date(y, m - 1, 1);
    const endDate = new Date(y, m, 0);

    loadMonthData(startDate, endDate, (data) => {
      const day = `${y}-${m}-${d}`;
      const isValid = checkAppointmentAvailability(day, amPmConverter(slot), data);
      cb(isValid);
      if (!isValid) {
         // add unavailable slot if it is not in response for deselection
        data[day] = assignObject({}, data[day], { [slot]: false });
      }

      // still in same month
      if (state.date.indexOf(`${y}-${m}`) === 0) {
        updateMonthData(startDate, endDate, data);
      }
    });
  };

  // let validationInterval;

  const validation = (_value) => {
    const shouldValidate = _value || input.classList.contains('validate');

    if (!shouldValidate) {
      input.classList.add('valid')
      JotForm.corrected(input);
      JotForm.runConditionForId(props.id.value);
      return;
    }

    if (!_value) {
      input.classList.remove('valid');
      JotForm.errored(input, window.JotForm.texts?.required || FORM_TEXTS.required);
      JotForm.runConditionForId(props.id.value);
      return;
    }

    validate(_value, (isValid) => {
      if (isValid) {
        input.classList.add('valid');
        JotForm.corrected(input);
        JotForm.runConditionForId(props.id.value);
        return;
      }

      const parts = _value.split(' ');
      const dateStr = parts[0];

      const date = new Date(dateStr);
      const day = getDay(date);
      const datetime = `${dayNames()[day]}, ${monthNames()[date.getMonth()]} ${intPrefix(date.getUTCDate())}, ${date.getFullYear()}`;

      const time = parts.slice(1).join(' ');
      const slotUnavailableText = window.JotForm.texts?.slotUnavailable || FORM_TEXTS.slotUnavailable;
      const errorText = slotUnavailableText.slotUnavailable.replace('{time}', time).replace('{date}', datetime);

      input.classList.remove('valid')
      JotForm.errored(input, errorText);
      JotForm.runConditionForId(props.id.value);
    });
  };

  const debouncedValidation = debounce(validation, 300);

  const setValue = (value) => {
    input.value = value ? toDateTimeStr(new Date(value.replace(/-/g, '/'))) : '';

    setState({
      value
    });

    // trigger input event for supporting progress bar widget
    input.triggerEvent('input');

    debouncedValidation(value);
  };

  const handleClick = (e) => {
    const { target } = e;

    if (!target || !target.classList) {
      return;
    }

    if (target.classList.contains('disabled') && !target.classList.contains('active')) {
      return;
    }

    e.preventDefault();
    const { value } = target.dataset;
    // formerValue can be undefined
    setValue(target.classList.contains('active') ? state.formerValue : value);
  };

  const setTimezone = (timezone) => {
    tzInput.value = timezone;
    let oldTimezone = state.timezone;
    setState({ timezone });
    if (input.value) {
      const date = oldTimezone ? toDateTimeStr(dz(new Date(input.value.replace(/-/g, '/')), getTimezoneOffset(oldTimezone), getTimezoneOffset(state.timezone))) : toDateTimeStr(new Date(input.value.replace(/-/g, '/')));
      setDate(date.split(' ')[0]);
      setState({ value: date });
      
      loadFormerValue(oldTimezone);

      input.value = state.value;
    }
  };

  const handleTimezoneChange = (e) => {
    const { target } = e;
    const { value: timezone } = target;
    setTimezone(timezone);
  };

  const setDate = date => setState({ date });

  const handleDateChange = (e) => {
    const { target } = e;
    const { value: date } = target.dataset;

    if (!date) return;
    setDate(date);
  };

  const handleMonthYearChange = (e) => {
    const { dataset, value: inputVal } = e.target;
    const { name } = dataset;
    if (!name) {
      return;
    }

    const { date } = state;
    const oldDate = new Date(date);
    const oldMonth = oldDate.getMonth();
    const oldYear = oldDate.getFullYear();
    const oldDay = oldDate.getUTCDate();

    const value = inputVal || e.target.getAttribute('value');

    if (name === 'month') {
      let newDate = new Date(oldYear, value, oldDay);
      let i = 1;
      while (`${newDate.getMonth()}` !== `${value}` && i < 10) {
        newDate = new Date(oldYear, value, oldDay - i);
        i++;
      }

      return setDate(toDateStr(newDate));
    }

    return setDate(toDateStr(new Date(value, oldMonth, oldDay)));
  };

  const toggleMobileState = () => {
    if (wrapper.classList.contains('isOpenMobile')) {
      wrapper.classList.remove('isOpenMobile');
    } else {
      wrapper.classList.add('isOpenMobile');
    }
  };

  const keepSlotsScrollPosition = () => {
    const visibleSlot = element.querySelector('.appointmentSlots.slots .slot.active, .appointmentSlots.slots .slot:not(.disabled).active');

    element.querySelector('.appointmentSlots.slots').scrollTop = visibleSlot ? visibleSlot.offsetTop : 0;
  };

  const setTimezonePickerState = () => {
    const { timezone } = state;
    const {
      autoDetectTimezone: { value: autoDetecTimezoneValue } = {}
    } = props;
    timezonePickerCommon.setSelectedTimezone(timezone);
    timezonePickerCommon.setIsAutoSelectTimezoneOpen(autoDetecTimezoneValue);
  };

  const loadFormerValue = (oldTimezone) => {
    const { formerValue = '' } = state;
    const date = oldTimezone ? toDateTimeStr(dz(new Date(input.value.replace(/-/g, '/')), getTimezoneOffset(oldTimezone), getTimezoneOffset(state.timezone))) : toDateTimeStr(new Date(input.value.replace(/-/g, '/')));
    const formerDate = formerValue ? (oldTimezone ? toDateTimeStr(dz(new Date(formerValue.replace(/-/g, '/')), getTimezoneOffset(oldTimezone), getTimezoneOffset(state.timezone))) : toDateTimeStr(new Date(formerValue.replace(/-/g, '/')))) : undefined;
    const formerDateTimezoned = oldTimezone ? formerDate : date 

    if (JotForm.isEditMode() && date && date !== formerValue) {
      setState({ formerValue:  formerDateTimezoned });
    }
  }

  const handleUIUpdate = () => {
    try {
      const breakpoints = {
        450: 'isLarge',
        225: 'isNormal',
        175: 'shouldBreakIntoNewLine'
      };

      const offsetWidth = (() => {
        try {
          const appointmentCalendarRow = element.querySelector('.appointmentFieldRow.forCalendar');
          const appointmendCalendar = element.querySelector('.appointmentCalendar');
          return appointmentCalendarRow.getBoundingClientRect().width - appointmendCalendar.getBoundingClientRect().width;
        } catch (e) {
          return null;
        }
      })();

      if (offsetWidth === null || parseInt(wrapper.getAttribute('data-breakpoint-offset'), 10) === offsetWidth) {
        return;
      }

      const breakpoint = Object.keys(breakpoints).reduce((prev, curr) => { return Math.abs(curr - offsetWidth) < Math.abs(prev - offsetWidth) ? curr : prev; });
      const breakpointName = breakpoints[breakpoint];

      wrapper.setAttribute('data-breakpoint', breakpointName);
      wrapper.setAttribute('data-breakpoint-offset', offsetWidth);
    } catch (e) {
      // noop.
    }
  };

  let uiUpdateInterval;

  const effects = () => {
    clearInterval(uiUpdateInterval);

    const shouldLoad = (changed.timezone && changed.timezone !== state.timezone) // time zone changed
      || (changed.date && getYearMonth(changed.date) !== getYearMonth(state.date)); // y-m changed

    changed = {};

    if (shouldLoad) {
      load();
    }

    const cancelAppointmentBtn = element.querySelector('.cancelAppointmentBtn');
    const cancelSelectionBtn = element.querySelector('.cancelSelectionBtn');

    if (cancelAppointmentBtn) {
      cancelAppointmentBtn.addEventListener('click', () => {
        setValue(undefined);
        setState({ formerValue: undefined });
      });
    }

    if (cancelSelectionBtn) {
      cancelSelectionBtn.addEventListener('click', () => {
        const { date = '', initialStartDate = '', formerValue = '' } = state;
        const isFormerDatePassed = hasDatePassed(formerValue, initialStartDate);
        const currentOrFormerDate = formerValue ? state.formerValue.split(' ')[0] : date;

        setDate(isFormerDatePassed ? initialStartDate : currentOrFormerDate);
        setValue(state.formerValue);
      });
    }

    const forSelectedDate = element.querySelector('.forSelectedDate span');

    if (forSelectedDate) {
      forSelectedDate.addEventListener('click', () => {
        setDate(state.value.split(' ')[0]);
      });
    }

    if (isTimezonePickerFromCommonLoaded) {
      setTimezonePickerState();
      const timezonePickerWrapper = element.querySelector('.forTimezonePicker');
      timezonePickerCommon.init(timezonePickerWrapper);
    } else {
      const timezonepicker = element.querySelector('.timezonePicker');
      if (timezonepicker) {
        timezonepicker.addEventListener('change', handleTimezoneChange);
      }
    }

    element.querySelector('.calendar .days').addEventListener('click', handleDateChange);
    element.querySelector('.monthYearPicker').addEventListener('change', handleMonthYearChange);
    element.querySelector('.dayPicker').addEventListener('click', handleDateChange);
    element.querySelector('.selectedDate').addEventListener('click', toggleMobileState);

    Array.prototype.slice.call(element.querySelectorAll('.monthYearPicker .pickerArrow')).forEach(el => el.addEventListener('click', handleMonthYearChange));
    Array.prototype.slice.call(element.querySelectorAll('.slot')).forEach(el => el.addEventListener('click', handleClick));

    keepSlotsScrollPosition();
    uiUpdateInterval = setInterval(handleUIUpdate, 250);

    JotForm.runAllCalculations();
  };

  const onTimezoneOptionClick = (timezoneValue) => {
    setTimezone(timezoneValue);
  };

  const renderMonthYearPicker = () => {
    const { date } = state;

    const [year, month] = (date || '-').split('-');
    const yearOpts = fillArray(new Array(20), '').map((v, i) => `${currentYear + i}`);

    const prevMonthButtonText = (props.prevMonthButtonText && props.prevMonthButtonText.text) || 'Previous month';
    const nextMonthButtonText = (props.nextMonthButtonText && props.nextMonthButtonText.text) || 'Next month';
    const prevYearButtonText = (props.prevYearButtonText && props.prevYearButtonText.text) || 'Previous year';
    const nextYearButtonText = (props.nextYearButtonText && props.nextYearButtonText.text) || 'Next year';

    return `
      <div class='monthYearPicker'>
        <div class='pickerItem'>
          <select class='pickerMonth' data-name='month' aria-label="Choose a month">
            ${monthNames().map((monthName, i) => `<option ${parseInt(month, 10) === i + 1 ? 'selected' : ''} value='${i}'>${monthName}</option>`).join('')}
          </select>
          <button type='button' class='pickerArrow pickerMonthArrow prev'
          ${Number(month) === 1 && Number(year) === currentYear && 'disabled'}
          value='${parseInt(month, 10) - 2}'
          data-name='month'
          aria-label="${prevMonthButtonText}"
          >
          </button>
          <button
          type='button'
          class='pickerArrow pickerMonthArrow next'
          ${Number(month) === 12 && Number(year) === currentYear + 19 ? 'disabled' : ''}
          value='${parseInt(month, 10)}'
          data-name='month'
          aria-label="${nextMonthButtonText}"
          >
          </button>
        </div>
        <div class='pickerItem'>
          <select class='pickerYear' data-name='year' aria-label="Choose a year">
            ${yearOpts.map(yearName => `<option ${year === yearName ? 'selected' : ''}>${yearName}</option>`).join('')}
          </select>
          <button
          type='button'
          class='pickerArrow pickerYearArrow prev'
          ${Number(year) === currentYear && 'disabled'}
          value='${parseInt(year, 10) - 1}'
          data-name='year'
          aria-label="${prevYearButtonText}"
          />
          <button
          type='button'
          class='pickerArrow pickerYearArrow next'
          ${Number(year) === currentYear + 19 && 'disabled'}
          value='${parseInt(year, 10) + 1}'
          data-name='year'
          aria-label="${nextYearButtonText}"
          />
        </div>
      </div>
    `;
  };

  const getNav = () => {
    const { availableDays, date: dateStr } = state;

    let next;
    let prev;
    const [year, month] = dateStr.split('-');
    if (availableDays) {
      const dayIndex = availableDays.indexOf(dateStr);
      if (dayIndex > 0) {
        prev = availableDays[dayIndex - 1];
      } else {
        const prevDate = new Date(year, month - 1, 0);
        if (prevDate.getFullYear() >= currentYear) {
          prev = toDateStr(prevDate);
        }
      }

      if (dayIndex + 1 < availableDays.length) {
        next = availableDays[dayIndex + 1];
      } else {
        const nextDate = new Date(year, month, 1);
        if (nextDate.getFullYear() <= currentYear + 19) {
          next = toDateStr(nextDate);
        }
      }
    }
    return { prev, next };
  };

  const renderDayPicker = () => {
    const { loading } = state;

    const { prev, next } = getNav();

    const prevDayButtonText = (props.prevDayButtonText && props.prevDayButtonText.text) || 'Previous day';
    const nextDayButtonText = (props.nextDayButtonText && props.nextDayButtonText.text) || 'Next day';

    return `
      <div class='appointmentDayPicker dayPicker'>
        <button type='button' ${loading || !prev ? 'disabled' : ''} class="appointmentDayPickerButton prev" ${prev && `data-value="${prev}"`} aria-label="${prevDayButtonText}">&lt;</button>
        <button type='button' ${loading || !next ? 'disabled' : ''} class="appointmentDayPickerButton next" ${next && `data-value="${next}"`} aria-label="${nextDayButtonText}">&gt;</button>
      </div>
    `;
  };

  const renderTimezonePicker = () => {
    const { timezone, timezones } = state;
    if (!timezones) return;

    return `
      <div class='timezonePickerWrapper'>
        <select class='timezonePicker'>
          ${!timezones.loading && (
            timezones.map(({ group, cities }) => (
              `
                <optgroup label="${group}">
                  ${cities.map(val => `<option ${timezone.indexOf(`${group}/${val}`.split(' ')[0]) > -1 ? 'selected' : ''} value='${group}/${val}'>${val}</option>`).join('')}
                </optgroup>
              `
            )).join('')
          )}
        </select>
        <div class='timezonePickerName'>${timezone}</div>
      </div>
    `;
  };

  const renderCalendarDays = () => {
    const { slots, date: dateStr, value, availableDays } = state;
    const days = slots ? Object.keys(slots) : [];
    const todayStr = toDateStr(new Date());

    if (!days.length) {
      return '';
    }

    const firstDay = getDay(new Date(days[0]));
    days.unshift(...fillArray(new Array(firstDay), 'precedingDay'));

    const trailingDays = (Math.ceil(days.length / 7) * 7) - days.length;
    days.push(...fillArray(new Array(trailingDays), 'trailingDay'));

    const weeks = days.map((item, i) => { return (i % 7 === 0) ? days.slice(i, i + 7) : null; }).filter(a => a);

    const dateValue = value && value.split(' ')[0];
  
    return `
      ${weeks.map((week) => {
        return `<div class='calendarWeek'>${
          week.map((day) => {
            const dayObj = new Date(day);
            if (day === 'precedingDay' || day === 'trailingDay') {
              return `<div class="calendarDay ${day} empty"></div>`;
            }
            const active = day === dateStr;
            const isToday = todayStr === day;
            const beforeStartDate = state.forcedStartDate ? state.forcedStartDate > dayObj : false;
            const afterEndDate = state.forcedEndDate ? state.forcedEndDate < dayObj : false;
            const isUnavailable = availableDays.indexOf(day) === -1 || beforeStartDate || afterEndDate;
            const isPassed = hasDatePassed(day);
            const isStartDayGreaterThanDay = hasDatePassed(day, state.initialStartDate);
            const isSelected = !isPassed && !isStartDayGreaterThanDay && day === dateValue;
            const isActive = !isPassed && !isStartDayGreaterThanDay && active;

            const classes = `calendarDay ${classNames({
              isSelected,
              isToday,
              isUnavailable,
              isActive,
            })}`;

            return `<div
                      class='${classes}'
                      data-value='${day}'
                      role="button"
                      aria-disabled="${isUnavailable ? true : false}"
                    >
                        <span class='calendarDayEach'>${day.split('-')[2].replace(/^0/, '')}</span>
                    </div>`;
          }).join('')
        }</div>`;
      }).join('')}
    `;
  };

  const renderEmptyState = () => {
    /* eslint-disable */
    return `
      <div class="appointmentSlots-empty">
        <div class="appointmentSlots-empty-container">
          <div class="appointmentSlots-empty-icon">
            <svg width="124" height="124" viewBox="0 0 124 124" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M46.5006 10.3333C46.5006 7.47986 44.1875 5.16666 41.334 5.16666C38.4805 5.16666 36.1673 7.47986 36.1673 10.3333V15.5H25.834C17.2736 15.5 10.334 22.4396 10.334 31V51.6667V103.333C10.334 111.894 17.2736 118.833 25.834 118.833H64.584C67.4375 118.833 69.7506 116.52 69.7506 113.667C69.7506 110.813 67.4375 108.5 64.584 108.5H25.834C22.9805 108.5 20.6673 106.187 20.6673 103.333V56.8333H103.334V64.5833C103.334 67.4368 105.647 69.75 108.501 69.75C111.354 69.75 113.667 67.4368 113.667 64.5833V51.6667V31C113.667 22.4396 106.728 15.5 98.1673 15.5H87.834V10.3333C87.834 7.47986 85.5208 5.16666 82.6673 5.16666C79.8138 5.16666 77.5006 7.47986 77.5006 10.3333V15.5H46.5006V10.3333ZM36.1673 25.8333V31C36.1673 33.8535 38.4805 36.1667 41.334 36.1667C44.1875 36.1667 46.5006 33.8535 46.5006 31V25.8333H77.5006V31C77.5006 33.8535 79.8138 36.1667 82.6673 36.1667C85.5208 36.1667 87.834 33.8535 87.834 31V25.8333H98.1673C101.021 25.8333 103.334 28.1465 103.334 31V46.5H20.6673V31C20.6673 28.1465 22.9805 25.8333 25.834 25.8333H36.1673ZM112.154 81.5966C114.172 83.6143 114.172 86.8857 112.154 88.9034L104.182 96.875L112.154 104.847C114.172 106.864 114.172 110.136 112.154 112.153C110.136 114.171 106.865 114.171 104.847 112.153L96.8756 104.182L88.904 112.153C86.8863 114.171 83.615 114.171 81.5973 112.153C79.5796 110.136 79.5796 106.864 81.5973 104.847L89.5689 96.875L81.5973 88.9034C79.5796 86.8857 79.5796 83.6143 81.5973 81.5966C83.615 79.5789 86.8863 79.5789 88.904 81.5966L96.8756 89.5682L104.847 81.5966C106.865 79.5789 110.136 79.5789 112.154 81.5966Z"/>
            </svg>
          </div>
          <div class="appointmentSlots-empty-text">${window.JotForm.texts?.noSlotsAvailable || FORM_TEXTS.noSlotsAvailable}</div>
        </div>
      </div>
    `;
    /* eslint-enable */
  };

  const dateWithAMPM = (date = '') => {
    const {
      timeFormat: { value: timeFormat = '24 Hour' } = {}
    } = props;
    const time = new Date(date.replace(/-/g, '/'))
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hourCycle: timeFormat === 'AM/PM' ? 'h12' : 'h23' });
    const day = date && date.split(' ')[0];
    return `${day} ${time}`;
  };


  const renderSlots = () => {
    const { date: dateStr, value: dateValue = '', defaultValue = '', timezone, forcedStartDate, forcedEndDate } = state;
    const dateSlots = (state.slots && state.slots[dateStr]) || {};

    const stateValue = dateWithAMPM(dateValue);
    const stateDefaultValue = dateWithAMPM(defaultValue);
    const defaultValueTZ = revertDate(defaultValue, ' ', timezone);

    const parsedDefaultVal = dateWithAMPM(defaultValueTZ);

    const entries = objectEntries(dateSlots);

    if (!entries || !entries.length) {
      return renderEmptyState();
    }

    return entries.map(([name, value]) => {
      if (name.indexOf('M') > -1) {
        name = name.split(' ');
        name = `${name[0]} ${name[1].locale()}`;
      }
      const rn = amPmConverter(name);
      const slotValue = `${dateStr} ${rn}`;
      const realD = new Date(slotValue.replace(/-/g, '/'));
      const active = stateValue.replace(/\s/g, ' ') === slotValue.replace(/\s/g, ' ');

      const disabled = (
        (((forcedStartDate && forcedStartDate > realD)
        || (forcedEndDate && forcedEndDate < realD)
        || !(value || parsedDefaultVal === slotValue))) && stateDefaultValue !== slotValue
      );

      return `<div class="appointmentSlot slot ${classNames({ disabled, active })}" data-value="${slotValue}" role="button">${name}</div>`;
    }).join('');
  };

  const renderDay = () => {
    const { date: dateStr } = state;
    const date = new Date(dateStr);
    const day = getDay(date);

    return `
      <div class='appointmentDate'>
        ${dateStr && `${dayNames()[day]}, ${monthNames()[date.getUTCMonth()]} ${intPrefix(date.getUTCDate())}`}
      </div>
    `;
  };

  const renderCalendar = () => {
    const { date: dateStr } = state;

    return `
      <div class='selectedDate'>
        <input class='currentDate' type='text' value='${toFormattedDateStr(dateStr)}' style='pointer-events: none;' aria-label="Selected Date" />
      </div>
      ${renderMonthYearPicker()}
      <div class='appointmentCalendarDays days'>
        <div class='daysOfWeek'>
          ${dayNames().map(day => (
            `<div class="dayOfWeek ${day.toLowerCase()}">${day.toUpperCase().slice(0, 3)}</div>`
          )).join('')}
        </div>
        ${renderCalendarDays()}
      </div>
    `;
  };

  const renderSelectedDate = () => {
    const { value = '', formerValue = '' } = state;
    const dateStr = value && value.split(' ')[0];
    const formerDateStr = formerValue && formerValue.split(' ')[0];
    const { calculateVal, time, datetime, unTranslatedDatetime } = convertStrToTime({ dateStr, value });
    const {
      time: formerTime,
      datetime: formerDateTime,
    } = convertStrToTime({ dateStr: formerDateStr, value: formerValue });
    const selectedTimeText = window.JotForm.texts?.selectedTime || FORM_TEXTS.selectedTime;
    const cancelSelectionText = window.JotForm.texts?.cancelSelection || FORM_TEXTS.cancelSelection;
    const cancelAppointmentText = window.JotForm.texts?.cancelAppointment || FORM_TEXTS.cancelAppointment;
    const formerSelectedText = window.JotForm.texts?.formerSelectedTime || FORM_TEXTS.formerSelectedTime;
    const text = `${time} ${datetime}`;
    const formerText = `${formerTime} ${formerDateTime}`;
    const hasFormerly = value !== formerValue;
    const appointmentDateTime = new Date(value.replace(/(\.|-)/g, '/')).getTime();
    const valEl = `<div style='display: none' class='jsAppointmentValue' data-untranslated='${unTranslatedDatetime} ${time}' data-calculate='${calculateVal} ${time}' data-date='${appointmentDateTime}'>${datetime} ${time}</div>`;
    const cancelAppointmentButton = `<button type='button' class='cancel cancelAppointmentBtn'>${cancelAppointmentText}</button>`;
    const cancelSelectionButton = `<button type='button' class='cancel cancelSelectionBtn'>${cancelSelectionText}</button>`;
    const selectedField = `<div class="forSelectedDateItem"><span class="forSelectedDateTitle" aria-live="polite">${selectedTimeText}</span><span aria-live="polite">${text}</span></div>`;
    const formerTimeField = `<div class="forSelectedDateItem forFormerly"><span class="forSelectedDateTitle" aria-live="polite">${formerSelectedText}</span><span aria-live="polite">${formerText}</span></div>`;
    const selectedFieldContainer =  `<div class='appointmentFieldRow forSelectedDate ${hasFormerly && 'hasFormerly'}'>
    ${selectedField}
    ${hasFormerly ? cancelSelectionButton : cancelAppointmentButton}
    ${JotForm.isEditMode() && formerValue && hasFormerly ? formerTimeField : ''}
    </div>`;

    return value ? `${valEl}${selectedFieldContainer}` : ``;  
  };

  const render = debounce(() => {
    const { loading } = state;
    const { text } = props
    beforeRender();
    element.innerHTML = `
      <div class='appointmentFieldContainer' aria-label="${text.value}" role="group">
        <div class='appointmentFieldRow forCalendar'>
          <div class='calendar appointmentCalendar'>
            <div class='appointmentCalendarContainer'>
              ${renderCalendar()}
            </div>
          </div>
          <div class='appointmentDates'>
            <div class='appointmentDateSelect'>
              ${renderDay()}
              ${renderDayPicker()}
            </div>
            <div class='appointmentSlots slots ${classNames({ isLoading: loading })}'>
              <div class='appointmentSlotsContainer'>
                ${renderSlots()}
              </div>
            </div>
            <div class='appointmentCalendarTimezone forTimezonePicker'>
              ${isTimezonePickerFromCommonLoaded ? '' : renderTimezonePicker()}
            </div>
          </div>
        </div>
        ${renderSelectedDate()}
      </div>
    `;
    afterRender();
    // Frame height needs to be recalculated and
    // updated after any UI change on appointment
    // field. We force it from here.
    try {
      global.JotForm.handleIFrameHeight();
    } catch (e) {
      // noop.
    }
  });

  const update = (newProps) => {
    state = assignObject({}, state, getStateFromProps(newProps));
    props = newProps;
    constructTimezonePickerCommon(props);
    load();
  };

  input.addEventListener('change', (e) => {
    const date = e.target.value ? toDateTimeStr(new Date(e.target.value.replace(/-/g, '/'))) : '';
    const isAMPM = props.timeFormat === '24 hour';
    if (date) {
      setDate(date.split(' ')[0]);
      setState({ value: date, defaultValue: isAMPM ? date : dateWithAMPM(date) });
      validation(isAMPM ? date : dateWithAMPM(date));
    }
  });
  tzInput.addEventListener('change', (e) => {
    const defaultTimezone = e.target.value;
    setTimezone(defaultTimezone);
    setState({ defaultTimezone });
  });
  document.addEventListener('translationLoad', () => render());

  const triggerConstruct = (timezones) => {
    JotForm.appointments.listeners.forEach(fn => fn({ timezones }));
  }

  if (!JotForm.appointments) {
    JotForm.appointments = { listeners: [] };

    loadTimezones((timezones) => {
      JotForm.timezones = timezones;

      if (JotForm.isEditMode()) {
        ensureEditResultSet(10000).then(()=> {
          triggerConstruct(timezones);
        });
      } else {
        triggerConstruct(timezones);
      }
    });
  }

  // Appointment flickers if we don't wait for submission result on edit
  function ensureEditResultSet(timeout) {
    var dateStart = Date.now();
    return new Promise(waitForEditResult);

    function waitForEditResult(resolve, reject) {
        if (JotForm.editValueSet)
            resolve();
        else if (timeout && (Date.now() - dateStart) >= timeout)
            resolve();
        else
            setTimeout(waitForEditResult.bind(this, resolve, reject), 30);
    }
  }

  const requestTimeout = 1000;

  const getFirstAvailableDates = async ({ formID, timezone, qid }) => {
    const url = `${PREFIX}?action=getAppointments&formID=${formID}&timezone=${encodeURIComponent(timezone)}&ncTz=${(new Date().getTime())}&firstAvailableDates&qid=${qid}`;
    const { content } = await getJSON(url);
    JotForm.appointments.initialData = {...JotForm.appointments.initialData, ...content}
    return content[qid];
  }

  const constructTimezonePickerCommon = (props) => {
    const isAm = props?.timeFormat?.value === 'AM/PM';
    const userTimezone = getUserTimezone();
    const timezone = state.defaultTimezone || userTimezone

    if (window.timezonePickerCommon) {
      isTimezonePickerFromCommonLoaded = true;
      timezonePickerCommon = window.timezonePickerCommon({
        id: uniqueId,
        timezones: JotForm.timezones,
        selectedTimezone: timezone,
        onOptionClick: onTimezoneOptionClick,
        usePortal: true,
        isAm
      });
    }
  }

  const construct = async ({ timezones }) => {
    const { formID = global.__formInfo.id, id: { value: qid }, autoDetectTimezone: { value: autoDetectValue } = {} } = props;

    const userTimezone = getUserTimezone();
    const timezone = state.defaultTimezone || userTimezone

    if (!formID || !timezone) return;

    if (autoDetectValue === 'No') {
      load();
    }

    const qdata = await getFirstAvailableDates({ formID, timezone, qid });

    if (!qdata || qdata.error) {
      constructed = true;
      return;
    }

    constructed = false;

    constructTimezonePickerCommon(props);

    setTimezone(timezone);
    const dateStr = Object.keys(qdata)[0];

    const [startDate, endDate] = getDateRange(dateStr);

    updateMonthData(startDate, endDate, qdata);
    const { availableDays } = state;
    const newDate = availableDays.indexOf(dateStr) === -1 ? availableDays[0] : dateStr;

    constructed = true;

    setState({
      timezones,
      loading: false,
      date: newDate || dateStr,
      initialStartDate: dateStr,
    });
    
    const isDatePassed = hasDatePassed(state.value);
    const isForcedStartDay = hasDatePassed(state.value, dateStr);

    // should wait for submission results for edit mode to correct input value for user timezone
    if (JotForm.isEditMode()) {
      ensureEditResultSet(10000).then(() => {
        // if appointment is passed, get first available day
        if (!isDatePassed && !isForcedStartDay) {
          input.triggerEvent('change');
          input.value = state.value || '';
        }
      })
    } else {
      setTimeout(() => {
        if (input.value) {
          input.triggerEvent('change');
        }
      }, 100);
    }
  };

  JotForm.appointments.listeners.push(construct);

  if (JotForm.appointments.initialData) {
    setTimeout(() => {
      construct({
        timezones: JotForm.timezones
      });
    }, requestTimeout);
  }

  JotForm.appointments[props.id.value] = {
    update: newProps => update(assignObject(passedProps, newProps)),
    forceStartDate: async (newDate, equation = '') => {
      if (!newDate) {
        setState({ forcedStartDate: undefined });
        return;
      }
      try {
        const forcedStartDate = new Date(newDate);
        if (`${forcedStartDate}` === `${state.forcedStartDate}`) return;
        let date = new Date(state.availableDays.find(d => new Date(`${d} 23:59:59`) >= forcedStartDate));

        if (!date.getTime()) {
          date = forcedStartDate;
        }

        date = toDateStr(date);

        if (equation && !state.loading) {
          const realDate = new Date(forcedStartDate.getTime());
          if (`${state.forcedStartDate}` === `${realDate}`) return;
          const getFirstAvailableDay = (_availableDays) => { return new Date(_availableDays.find(d => new Date(`${d} 23:59:59`) >= realDate)) };
          let firstAvailableDay = getFirstAvailableDay(state.availableDays);

          if (firstAvailableDay.toString() === 'Invalid Date') {
            const [startDate, endDate] = getDateRange(toDateStr(realDate));
            const monthData = await getMonthData(startDate, endDate);
            const { availableDays } = generateMonthData(startDate, endDate, monthData);
            firstAvailableDay = getFirstAvailableDay(availableDays);
          }

          setValue('');
          setState({ forcedStartDate, date: toDateStr(firstAvailableDay) });
          return;
        }

        setState({ forcedStartDate, date });
      } catch (e) {
        console.log(e);
      }
    },
    forceEndDate: (newDate) => {
      if (!newDate) {
        setState({ forcedEndDate: undefined });
        return;
      }

      try {
        const forcedEndDate = new Date(newDate);
        if (`${forcedEndDate}` === `${state.forcedEndDate}`) return;
        const availableDays = state.availableDays.filter(d => new Date(`${d} 00:00:00`) <= forcedEndDate);

        let date = new Date(
          availableDays.indexOf(state.date) > -1
          ? state.date
          : availableDays[availableDays.length - 1]
        );

        if (!date.getTime()) {
          date = forcedEndDate;
        }

        date = toDateStr(date);

        setState({ forcedEndDate, date });
      } catch (e) {
        console.log(e);
      }
    },
    getComparableValue: () => (
      input.value && toDateTimeStr(new Date(input.value.replace(/-/g, '/')))
    ) || ''
  };

  return update;
};
